import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';

import { RouterLink } from 'src/routes/components';

import { Container } from '@mui/material';
import PageNotFoundIllustration from '../page-not-found-illustration';

export default function NotFoundView() {
  return (
    <Container>
      <Typography variant="h3" sx={{ mb: 2 }}>
        Sorry, Page Not Found!
      </Typography>

      <Typography sx={{ color: 'text.secondary' }}>
        Sorry, we couldn’t find the page you’re looking for. Perhaps you’ve mistyped the URL? Be
        sure to check your spelling.
      </Typography>

      <PageNotFoundIllustration
        sx={{
          height: 260,
          my: { xs: 5, sm: 10 },
        }}
      />

      <Button component={RouterLink} href="/" size="large" variant="contained">
        Go to Home
      </Button>
    </Container>
  );
}
